import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'

export let startOrgKeyManagement = (isAdmin) => {
  const root = createRoot(document.getElementById('orgKeyManagementApp'))
  root.render(<App isAdmin={isAdmin} />)
}
